<template>
  <section class="bg-[#D9D9D9] overflow-x-hidden">
    <!-- <SocialHead
      :title="`${product.name} - Price, Specs, Mileage, Images, Features`"
      :description="product.short_description"
      :image="
        state.defaultColor &&
        state.defaultColor.cover.length &&
        state.defaultColor.cover[0].url_md
      "
    /> -->
    <!-- 360° view -->
    <BannerWrapper hero>
      <Banner
        class="banner-product"
        :colors="{
          background: 'transparent',
          textColor: '#000',
        }"
        product-section
        appear-visible
      >
        <template #headline>
          <span
            class="text-[36px] md:text-[28px] lg:text-[52px] leading-[38px] lg:leading-[50px] text-[#000] font-myriad-pro-condensed font-bold"
          >
            {{ product.name }}
          </span>
        </template>

        <template #subheadline>
          <p
            v-if="product.short_description"
            class="text-base px-4 xl:leading-[32px] leading-[24px] text-[#000] xl:text-[22px] font-myriad-pro-condensed font-normal italic"
            v-text="product.short_description"
          />
        </template>

        <div>
          <!-- media: 360 -->
          <div
            v-if="state.defaultColor && state.defaultColor['360'].length > 0"
            class="h-[226px] flex items-center justify-center w-full sm:h-[330px] md:w-[635px] md:h-[360px] lg:w-[745px] lg:h-[419px] mt-2 mb-4 md:my-2 mx-auto"
          >
            <div v-if="SpriteSpinCanvas">
              <component
                :is="SpriteSpinCanvas"
                :key="state.defaultColor.color"
                :frames="state.defaultColor['360'].map((i) => i.url_hd)"
              />
            </div>
          </div>
          <!-- media: cover -->
          <div
            v-else-if="
              state.defaultColor &&
              state.defaultColor.cover &&
              state.defaultColor.cover.length > 0
                ? state.defaultColor.cover[0].url_hd
                : null
            "
            class="h-[226px] w-full sm:h-[330px] md:max-w-[560px] md:h-[360px] lg:max-w-[657px] lg:h-[419px] max-w-full mx-auto mt-2 mb-6 md:my-2"
          >
            <img
              :key="state.defaultColor.color"
              :src="state.defaultColor.cover[0].url_hd"
              :src-placeholder="state.defaultColor.cover[0].url_placeholder"
              class="object-cover sm:w-[520px] w-[350px] md:w-full h-full"
            />
          </div>
          <!-- Variants -->
          <ProductVariants
            :defaultColor="state.defaultColor"
            :colors="state.colors"
            :variants="state.variants"
            @selected-color="(c) => (state.defaultColor = c)"
          />
        </div>
      </Banner>
    </BannerWrapper>

    <span id="top-specs" class="pt-7.5 block"></span>
    <!-- Top Specs -->
    <section
      :class="product.id !== 114 && product.id !== 117 ? 'md:mb-8' : 'md:mb-8'"
      class="container relative z-10 flex items-center justify-center px-0 lg:px-8 md:mt-[50px] lg:mt-0 mt-[100px]"
    >
      <!-- <h1
        class="block lg:hidden text-2xl md:text-[32px] lg:text-[38px] xl:text-[42px] text-[#404040] text-center uppercase font-bold px-4 pt-5 lg:pt-12 md:pt-0 pb-4"
        v-text="$t('common.top_specs')"
      /> -->
      <div
        :class="
          product.id !== 114 && product.id !== 117
            ? ''
            : 'block lg:flex lg:!w-auto md:mb-16 lg:pr-8'
        "
        class="top-specs-container mt-[-70px] md:mt-[-36px] lg:mt-[-5px] w-[94%] md:w-[80%] lg:w-[72%] xl:w-[65%] bg-white rounded-[0.125rem] shadow-xl absolute top-[-0.8rem] overflow-hidden"
      >
        <div
          class="grid grid-cols-2 lg:flex lg:divide-x lg:rtl:divide-x-reverse divide-[#E6E6E6] py-4 lg:py-6 auto-rows-fr"
        >
          <div
            v-if="product.id !== 114 && product.id !== 117"
            class="relative flex flex-col !flex-1 w-full pl-4 pr-1 text-left item rtl:text-right lg:pr-7 lg:pl-8"
          >
            <h5
              class="text-sm text-[#666666] text-[10px] md:text-base uppercase font-myriad-pro-condensed font-bold whitespace-nowrap m-0 pb-1"
            >
              {{ $t("common.price_from") }}
            </h5>
            <p
              class="font-normal font-myriad-pro whitespace-nowrap text-[14px] leading-[22px] md:text-[16px] text-black md:leading-[24px]"
            >
              {{
                product.min_price && parseFloat(product.min_price) > 0
                  ? $formatPrice(product.min_price)
                  : "N/A"
              }}
            </p>
          </div>
          <!-- Power -->
          <div
            v-if="state.topData"
            :class="
              product.id !== 114 && product.id !== 117
                ? 'relative flex flex-col w-full pl-4 pr-1 text-left item rtl:text-right lg:px-4'
                : 'relative flex flex-col !flex-1 w-full pl-4 pr-1 text-left item rtl:text-right lg:pr-7 lg:pl-8'
            "
          >
            <h5
              class="text-sm text-[#666] uppercase text-[10px] md:text-base font-myriad-pro-condensed italic font-bold whitespace-nowrap m-0"
            >
              {{ $t("common.power") }}
            </h5>
            <p
              class="md:mt-1 font-normal whitespace-nowrap font-myriad-pro text-[14px] leading-[22px] md:text-[16px] text-[#000] md:leading-[24px]"
            >
              {{ state.topData[0]?.content ? state.topData[0].content : "N/A" }}
            </p>
          </div>
          <!-- Max torque -->
          <div
            v-if="state.topData"
            :class="
              product.id !== 114 && product.id !== 117
                ? 'border-t lg:border-t-0 pt-3 lg:pt-0 pl-4 pr-1 '
                : 'pl-1 pr-4 pt-0 border-t-0 lg:border-t-0'
            "
            class="item w-full flex flex-col text-left rtl:text-right lg:px-4 relative border-[#E6E6E6] lg:border-t-0 pt-0"
          >
            <h5
              class="text-sm text-[#666] text-[10px] md:text-base uppercase font-myriad-pro-condensed font-bold whitespace-nowrap m-0"
            >
              {{ $t("common.max_torque") }}
            </h5>
            <p
              class="md:mt-1 font-normal whitespace-nowrap font-myriad-pro text-sm leading-[22px] md:text-base text-[16px] text-[#000] md:leading-[24px]"
            >
              {{ state.topData[1]?.content ? state.topData[1].content : "N/A" }}
            </p>
          </div>
          <!-- Dry weight -->
          <div
            v-if="state.topData"
            :class="
              product.id !== 114 && product.id !== 117
                ? 'item w-full flex !flex-1 flex-col text-left rtl:text-right px-[1rem] pr-1 pl-4 lg:pr-8 lg:pl-5 relative border-t lg:border-t-0 border-[#E6E6E6] pt-3 lg:pt-0'
                : 'relative flex flex-col !flex-1 w-full pl-4 pr-1 text-left item rtl:text-right lg:pr-8 lg:pl-4 border-t lg:border-t-0 pt-3 lg:pt-0'
            "
          >
            <h5
              class="text-sm text-[#666] uppercase md:text-base italic leading-[16px] font-myriad-pro-condensed font-bold whitespace-nowrap m-0"
            >
              {{ $t("common.dry_weight") }}
            </h5>

            <p
              class="md:mt-1 font-normal whitespace-nowrap font-myriad-pro text-sm leading-[22px] md:text-base text-[16px] text-[#000] md:leading-[24px]"
            >
              {{ state.topData[2]?.content ? state.topData[2].content : "N/A" }}
            </p>
          </div>
          <!-- Price -->
          <div
            v-if="product.id == 114 || product.id == 117"
            class="item w-full flex !flex-1 flex-col text-left rtl:text-right px-[1rem] pr-4 pl-1 lg:pr-8 lg:pl-5 relative border-t lg:border-t-0 border-[#E6E6E6] pt-3 lg:pt-0"
          >
            <h5
              class="text-sm text-[#666666] text-[10px] md:text-base uppercase font-myriad-pro-condensed font-bold whitespace-nowrap m-0 pb-1"
            >
              {{ $t("common.price_from") }}
            </h5>
            <p
              class="font-normal font-myriad-pro whitespace-nowrap text-[14px] leading-[22px] md:text-[16px] text-black md:leading-[24px]"
            >
              {{
                product.min_price && parseFloat(product.min_price) > 0
                  ? $formatPrice(product.min_price)
                  : "N/A"
              }}
            </p>
          </div>
        </div>
        <div
          v-if="product.id == 114 || product.id == 117"
          class="m-4 mt-0 lg:mx-auto lg:my-auto"
        >
          <a
            target="_"
            :href="
              product.id === 114
                ? 'https://benelliimperiale-amc.com/benelli'
                : 'https://benelliimperiale-amc.com/benelli/trk-502x'
            "
            class="ml-auto h-[50px] flex justify-center items-center text-white bg-emerald-500 px-5 py-3 rounded-[10px] lg:rounded-[8px]"
          >
            <span
              class="text-lg font-normal leading-relaxed uppercase whitespace-nowrap"
            >
              {{ $t("common.buy_now") }}
            </span>
          </a>
        </div>
      </div>
    </section>

    <!-- <section class="mx-auto mt-8 overflow-hidden md:mt-0"> -->
    <!-- <div class="container"> -->
    <!-- Inventories total -->
    <!-- <div v-show="mainStore.enableShop" class="flex flex-col items-center justify-between mb-4 overflow-hidden sm:text-center sm:py-6 md:mb-0 last:mb-0">
          <h5 class="text-xl text-gray-400 uppercase" v-text="$t('common.inventories')" />
          <p class="js-bounty">
            <span class="bounty-total-inventory" />
          </p>
        </div> -->

    <!-- Top Specs -->
    <!-- <section v-if="Object.keys(state.topData).length >= 1" class="container relative z-10 px-8 my-8">
          <div class="top-specs-container bg-white rounded-[0.125rem]">
            <div class="flex flex-col flex-wrap items-stretch justify-start lg:flex-row">
              <div v-for="(topSpec, index) in state.topData" :key="index" class="item w-auto text-left px-[2.5rem] py-[1.5rem] relative after:w-[0.0625rem] after:h-[50%] after:bg-[#999999] after:absolute after:top-[50%] after:right-[100%] after:translate-y-[-50%] first:after:w-0">
                <h5 class="text-xs text-[#666666] uppercase font-bold">{{ topSpec.name }}</h5>
                <p class="js-bounty">
                  <span :class="`bounty-${index}`" />
                </p>
              </div>
            </div>
          </div>
        </section> -->
    <!-- </div>
    </section> -->

    <!-- Subnav -->
    <ProductNavSection
      :product-item="product"
      :product-slug="product.slug"
      :inventory-total="state.productTotalInventories"
      :product-category="
        product.categories &&
        product.categories.length &&
        product.categories[0].name
      "
      :product-name="product.name"
      :has-introduction="hasIntroduction"
      :has-gallery="hasGallery"
      :has-top-features="hasTopFeatures"
      :has-specifications="hasSpecifications"
      :has-faqs="hasFaq"
    />

    <!-- Inventories -->
    <ProductInventories
      v-if="mainStore.enableShop"
      :product-slug="product.slug"
    />

    <div
      v-if="!hasIntroduction && !hasTopFeatures && !hasSpecifications"
      class="bg-white py-28"
    />

    <!-- Introduction -->
    <ProductIntroduction
      v-if="product.description"
      :product-id="product.id"
      :product-description="product.description"
      :class="hasTopFeatures ? 'pt-24 lg:pt-28 pb-0' : 'pt-24 lg:pt-28 pb-16'"
    />

    <!-- Top features -->
    <ProductTopFeatures
      v-if="hasTopFeatures"
      :product-top-features="state.productTopFeatures"
      :has-product-introduction="hasIntroduction"
      :class="hasIntroduction ? 'pt-8 lg:pt-16' : 'pt-8 lg:pt-28'"
    />

    <!-- Photos and videos -->
    <ProductGallery
      v-if="state.gallery && state.gallery.length > 0"
      :gallery="state.gallery"
      :name="product.name"
    />

    <!-- Technical specifications -->
    <ProductSpecification
      v-if="hasSpecifications"
      :product-slug="state.productAttributes"
      :product-top-features="state.productTopFeatures"
      :has-product-introduction="hasIntroduction"
      :class="
        hasIntroduction || hasTopFeatures ? 'pt-8 lg:pt-16' : 'pt-8 lg:pt-28'
      "
    />

    <!-- Product Faqs -->
    <ProductFaqs id="faqs" :product-slug="product.slug" @has-faq="setFaq" />
  </section>
</template>

<script setup>
/* eslint-disable */
import InventoriesModal from "~/modals/InventoriesModal";
import { useMainStore } from "@/store/index";
import { useModal } from "vue-final-modal";

const importBouty = async () => {
  window.bounty = await import("bounty/lib/bounty.js");
};
let SpriteSpinCanvas = null;
if (process.browser) {
  SpriteSpinCanvas = defineAsyncComponent(() =>
    import("~/components/SpriteSpinCanvas.client.vue")
  );

  importBouty();
}

const route = useRoute();
const router = useRouter();
const mainStore = useMainStore();
const errorData = useError();
const nuxtApp = useNuxtApp();
const $config = useRuntimeConfig().public;

const isProductPage = ref(false);
const hasFaq = ref(false);
let product = reactive({});
const hasIntroduction = ref(false);
const hasTopFeatures = ref(false);
const hasGallery = ref(false);
const hasSpecifications = ref(false);
const hasGeometries = ref(false);
const productSeoData = ref(null);

let state = reactive({
  productTotalInventories: [],
  productAttributes: [],
  productGeometries: [],
  productTopFeatures: [],
  gallery: [],
  colors: [],
  defaultColor: null,
  variants: null,
  topData: null,
});

try {
  const { data, error } = await useAPI(
    `api/front/products/v2/${route.params.slug}?true`
  );
  const dataObj = data.value.data;

  state.productTotalInventories = dataObj.total_inventories;
  product = dataObj.product;
  productSeoData.value = dataObj.seo;
  state.productAttributes = dataObj.attributes;
  state.productGeometries = dataObj.geometry;
  state.productTopFeatures = dataObj.top_features;
  state.gallery = dataObj.media.gallery.concat(
    dataObj.media.colors.flatMap((e) => e.gallery)
  );
  state.colors = dataObj.media.colors;
  state.defaultColor = dataObj.media && dataObj.media.colors[0];
  state.variants = [];

  state.colors.forEach((element) => {
    if (element.menu.length >= 1) {
      state.variants.push(true);
    }
  });

  hasIntroduction.value = !!product.description;
  hasSpecifications.value = !!state.productAttributes;
  hasGallery.value = state.gallery ? state.gallery.length > 0 : false;
  hasTopFeatures.value = state.productTopFeatures
    ? state.productTopFeatures.length > 0
    : false;
  hasGeometries.value = !!state.productGeometries;

  state.topData = state.productAttributes
    .filter(
      (a) =>
        a.slug === "power" || a.slug === "max-torque" || a.slug === "dry-weight"
    )
    .map(function (a) {
      return {
        name: a.name,
        content: a.values[0]["content"],
      };
    });

  /* if (state.productGeometries && state.productGeometries.sizes && state.productGeometries.sizes[5] && state.productGeometries.sizes[5][1]) {
        state.topData.push({
          name: state.productGeometries.sizes[5][1],
          content: state.productGeometries.sizes[5][2] || 'N/A',
        })
      } */
} catch (e) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page Not Found",
  });
}

const currencyToken = computed(() => {
  return mainStore.currentSite && mainStore.currentSite.default_currency_token
    ? mainStore.currentSite.default_currency_token
    : "$";
});

watch(
  router.currentRoute,
  (newValue, oldValue) => {
    if (newValue.name == "country-products-slug") {
      isProductPage.value = true;
    } else {
      isProductPage.value = false;
    }
  },
  { deep: true }
);

onMounted(async () => {
  if (process.browser) {
    isProductPage.value = window.location.href.includes("/products/");

    // Object.keys(this.topData).forEach((obj, index) => {
    //   if (index >= 0) {
    //     window.bounty({
    //       el: `.bounty-${index}`,
    //       value: this.topData[index].content,
    //       duration: 1500,
    //       animationDelay: 200 * (index + 1)
    //     })
    //   }
    // })

    // Power
    // window.bounty({
    //   el: '.bounty-power',
    //   value: this.topData[0]?.content ? this.topData[0].content : 'N/A',
    //   duration: 1500,
    //   animationDelay: 200
    // })

    // Max torque
    // window.bounty({
    //   el: '.bounty-max-torque',
    //   value: this.topData[1]?.content ? this.topData[1].content : 'N/A',
    //   duration: 1500,
    //   animationDelay: 200
    // })

    // Seat height
    // window.bounty({
    //   el: '.bounty-dry-weight',
    //   value: this.topData[2]?.content ? this.topData[2].content : 'N/A',
    //   duration: 1500,
    //   animationDelay: 200
    // })

    // Price
    // window.bounty({
    //   el: '.bounty-price-from',
    //   value: this._data.product.min_price ? `$${this._data.product.min_price}` : 'N/A',
    //   duration: 1500,
    //   animationDelay: 200
    // })

    // window.bounty({
    //   el: '.bounty-total-inventory',
    //   value: this._data.productTotalInventories,
    //   duration: 1500,
    //   animationDelay: 200
    // })

    if (window.gtag) {
      window.gtag("event", "view_item", {
        items: [
          {
            id: product.slug,
            name: product.name,
          },
        ],
      });
    }

    await nextTick();
    const videos = document.querySelectorAll("video");

    if (videos && videos.length >= 1) {
      const options = {
        rootMargin: "0px 0px -20% 0px",
      };

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play();
          } else {
            entry.target.pause();
          }
        });
      }, options);

      Array.prototype.forEach.call(videos, (video) => {
        observer.observe(video);
      });
    }
  }
});

function setFaq(e) {
  hasFaq.value = e;
}

const { open, close } = useModal({
  component: InventoriesModal,
  attrs: {
    productSlug: product.slug,
  },
});

const openInventoriesModal = open;

useSchemaOrg([
  {
    "@type": "Product",
    "@id": $config.APP_URL + router.currentRoute._rawValue.fullPath,
    name: product.title,
    url: $config.APP_URL + router.currentRoute._rawValue.fullPath,
    image:
      state.defaultColor &&
      state.defaultColor.cover.length &&
      state.defaultColor.cover[0].url_md,
    description: product.short_description,
    offers: {
      "@type": "Offer",
      priceCurrency: nuxtApp.$currency,
      price:
        product.min_price && parseFloat(product.min_price) > 0
          ? nuxtApp.$formatPrice(product.min_price)
          : "N/A",
    },
  },
]);
let seoData = {
  page_title: product.name,
  meta_name: product.name,
  meta_description: product.short_description,
  model_id: route.params.slug,
  model_type: "Product",
  og_name: product.name,
  og_description: product.short_description,
  og_image:
    state.defaultColor &&
    state.defaultColor.cover.length &&
    state.defaultColor.cover[0].url_md,
};
if (productSeoData.value) {
  seoData = {
    ...seoData,
    ...productSeoData.value,
  };
}
nuxtApp.$seoModule(seoData);
</script>

<style lang="postcss">
.banner-product {
  @apply pt-[60px];
}

@media only screen and (max-width: 425px) {
  .banner-product .banner__inner {
    @apply pb-0;
  }
}

.banner-product .banner__inner img {
  @apply mx-auto;
}

.js-bounty {
  @apply text-[#5A5A5A] text-base fill-current font-bold inline-block mx-auto lg:mx-0;
}

.top-specs-container {
  .item {
    flex: 0 1 auto;
  }
}
</style>
